export default __webpack_public_path__ + "static/media/home-image.4de669c8.png";